






























































































import Vue from 'vue';
import { getLabelStyle } from '../../helper/components/AiLabelSelector_helper';

export default Vue.extend({
  props: {
    items: {
      type: Array,
      default: () => [] as any
    },
    value: {
      required: true
    },
    menuProps: {
      required: false,
      default: () => ({})
    },
    hideDetails: {
      default: false
    },
    dense: {
      default: true
    }
  },
  computed: {
    stringValItems() {
      if (this.items.length > 0) {
        return this.items.map((item: { value: any }) => {
          if (typeof item === 'object') {
            return {
              ...item,
              value: typeof item.value === 'object' ? JSON.stringify(item.value) : item.value
            };
          }

          return item;
        });
      } else {
        return [];
      }
    }
  },
  data() {
    return {
      selected: '' as any,
      parentWidth: ''
    };
  },
  methods: {
    handleClick(e: HTMLElement) {
      this.$emit('click', e);
      const parentEl: any = this.$refs.refs_selector;
      parentEl?.offsetWidth ? (this.parentWidth = parentEl.offsetWidth - 1 + 'px') : null;
    },
    getLabelStyle(type: string): object {
      return getLabelStyle(type);
    },
    isObject(item) {
      return typeof item === 'object';
    }
  },
  watch: {
    value: {
      handler(n) {
        if (typeof n === 'object') {
          this.selected = JSON.stringify(n);
        } else {
          this.selected = n;
        }
      },
      deep: true
    },
    selected: {
      handler(n) {
        try {
          const json = JSON.parse(n);
          this.$emit('input', json);
        } catch (e) {
          this.$emit('input', n);
        }
      }
    }
  },
  mounted() {
    if (typeof this.value === 'object') {
      this.selected = JSON.stringify(this.value);
    } else {
      this.selected = this.value;
    }
  }
});
